/** @format */

import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import CommonCardHeader from "../../Utils/CommonComponents/CommonCardHeader";

import SettingForm from "./Data";

export default function SettingsPage() {
  return (
    <div className="page-body main-project">
      <Container fluid>
        <Row>
          <Col sm={12}>
            <Card>
              <CommonCardHeader title="Settings" />
              <CardBody>
                <SettingForm />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
